import { ReactNode } from "react";
import EmptyImage from "./EmptyImage.png";
import styles from "./NoImpactBanner.module.scss";
import NoImpactImage from "./NoImpactImage.png";

export default function NoImpactBanner({
  title,
  children,
  size = "normal",
}: {
  title: ReactNode;
  children: ReactNode;
  size?: "small" | "normal";
}) {
  return (
    <div className={[styles.NoImpactBanner, styles[size]].join(" ")}>
      <div className={styles.emptyIcon}>
        <img
          src={EmptyImage}
          alt="Empty"
        />
      </div>
      <div className={styles.message}>
        <div className={styles.title}>{title}</div>
        {children}
      </div>
      <div className={styles.image}>
        <img
          src={NoImpactImage}
          alt="No Impact"
        />
      </div>
    </div>
  );
}
